import * as React from 'react'

import * as r from '../../../react-utils'

import MaterialIcons from 'react-native-vector-icons/MaterialIcons'
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom'

import * as gs from '../../../app/gStyles'
import { useIsSigningSession } from '../../fire'

//@ts-ignore
import styles from './Breadcrumbs.module.css'

export default React.memo(function Breadcrumbs() {
  const t = r.useTheme()

  const { customerID } = useParams<'customerID'>()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const [customerName] = r.useCustomerField(customerID!, 'customerName')

  const isCustomerReport = location.pathname.endsWith('/report')
  // Public token-signing flow (see SignContractPage/CustomerReport): the
  // customer should never see (or be tempted to click) links to other app
  // areas. Checks the signed-in account too, not just the URL param, which
  // was bypassable by deleting it from the URL bar (V50).
  const isSigningSession = useIsSigningSession()
  const readOnly = searchParams.get('mode') === 'sign' || isSigningSession

  if (readOnly) {
    return null
  }

  return (
    <div className={styles['breadcrumbs']}>
      {gs.colGap24}

      <Link className={styles['breadcrumbs-content']} to="/customers">
        <MaterialIcons color={t.brand__color} name="home" size={iconSize} />
        {gs.colGap8}
        <span className={styles['text']}>Dashboard</span>
      </Link>

      {!!customerID && (
        <>
          <span className={styles['text']}>{'/'}</span>

          <Link
            className={styles['breadcrumbs-content']}
            to={`/customers/${customerID}`}
          >
            <MaterialIcons
              color={t.brand__color}
              name="person"
              size={iconSize}
            />
            {gs.colGap8}
            <span className={styles['text']}>{customerName}</span>
          </Link>
        </>
      )}

      {isCustomerReport && (
        <>
          <span className={styles['text']}>{'/'}</span>

          <div className={styles['breadcrumbs-content']}>
            <MaterialIcons
              color={t.brand__color}
              name="assessment"
              size={iconSize}
            />
            {gs.colGap8}
            <span className={styles['text']}>Report</span>
          </div>
        </>
      )}
    </div>
  )
})

const iconSize = 16
